export const CHANGE_CURRENTPART = 'CHANGE_CURRENTPART';
export const GET_ALL_DATA = 'GET_ALL_DATA';
export const GET_PART_DATA = 'GET_PART_DATA';
export const LOAD_MORE = 'LOAD_MORE';
export const IS_SHOW_POP = 'IS_SHOW_POP';
export const IS_SHOW_ALL_PART = 'IS_SHOW_ALL_PART';
export const GET_APPLY_NUM = 'GET_APPLY_NUM';
export const INITINFO = 'INITINFO';
export const CURRENTSCROLLTOP = 'CURRENTSCROLLTOP';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js